import GSAP from 'gsap';
import each from 'lodash/each';
import Page from '@averyano/core/src/classes/Page';
import FaqSection from './FaqSection';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ProductController from '../../components/OnlineStore/product-controller';
import MarqComponent from '../../components/MarqComponent';

export default class ProductViewPage extends Page {
	constructor(el) {
		super({
			element: '.instore',
			elements: {
				wrapper: '.instore__wrapper',
				productWrapper: '.instore__product-wrapper',
				left: {
					wrapper: '.instore__left',
					figure: '.instore__figure',
					imgWrappers: '.instore__img-wrapper',
				},
				right: {
					wrapper: '.instore__right',
					items: '.instore__item',
					frameItems: '.instore__item-list-item--frame',
					sizeItems: '.instore__item-list-item--size',
					addToWishlistBtn: '#add-to-wishlist',
					priceText: '.instore__price',
				},
			},
		});

		this.id = 'productview';
		this.isCreated = false;
		this.isDragging = false;
		this.itemId = null;
	}

	create() {
		if (this.template != this.id) return;
		if (!this.isReady) super.createComponent();
		if (!this.isCreated) {
			this.components = {
				// cover: new CoverSection(),
				// exhibition: new ExhibitionSection(),
				// donation: new DonationSection(),
				// campaign: new CampaignSection(),
				marq: new MarqComponent({
					element: '.marq',
					html: `<div class="marq__stack"><span>${
						FRONTJS[window.locale].freeshipping
					}</span><svg class="marq__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24,12c-9.19,0-12,2.81-12,12,0-9.19-2.81-12-12-12,9.19,0,12-2.81,12-12,0,9.19,2.81,12,12,12Z" fill="rgb(var(--data-color-white))"></path></svg></div>`,
				}),
				faq: new FaqSection({ opened: true }),
			};
			this.isCreated = true;
		}
		console.log('🔼 Create productview Page');

		super.create();

		this.addEventListeners();

		each(this.components, (component) => {
			if (component.createComponent) component.createComponent();
		});
		// window.$ga.trackEvent('Page View', {
		// 	action: 'Visit',
		// 	label: '/' + this.id,
		// });
		console.log(this.id);
		console.log(`🔼 ${this.id} is created`);
		console.log('🌸🌸🌸');
		this.itemId = this.element.dataset.id;
		this.currentProduct = STOREPRODUCTS[window.locale].find(
			(product) => product.id === this.itemId
		);
		this.currentProductIndex = STOREPRODUCTS[window.locale].findIndex(
			(product) => product.id === this.itemId
		);

		each(this.components, (component) => {
			component.create();
			if (component.addEventListeners) component.addEventListeners();
		});
		console.log(this.currentProduct);

		this.selectedSizeElement = document.querySelector(
			'.instore__item-list-item--size.active'
		);
		this.selectedFrameElement = document.querySelector(
			'.instore__item-list-item--frame.active'
		);
		console.log('Selected size and frame:');
		console.log(this.selectedSizeElement.dataset.item);
		console.log(this.selectedFrameElement.dataset.item);

		ProductController.loadProduct(this.currentProduct);
		ProductController.selectSize(this.selectedSizeElement.dataset.item);
		ProductController.selectFrame(this.selectedFrameElement.dataset.item);
		ProductController.updatePrice();
		this.updatePriceText();
		console.log(ProductController);
		// window.scrollTo(0, 0);
	}

	createScrollTrigger() {
		if (window.isMobile) return;

		let scrollLength = 0;
		each(this.elements.left.imgWrappers, (img, i) => {
			const imgHeight = img.getBoundingClientRect().height;

			if (i >= this.elements.left.imgWrappers.length - 2) return;
			scrollLength += imgHeight;
		});
		GSAP.to(this.elements.left.wrapper, {
			y: -scrollLength,
			ease: 'none',
			scrollTrigger: {
				// trigger: this.element,
				start: 'top top',
				end: `bottom bottom`,
				scrub: true,
				pin: true,
				anticipatePin: 1,
				// markers: true,
			},
		});
		// We want to scroll images in the this.elements.left.wrapper first
		// then we allow the user to scroll the page
		// GSAP.registerPlugin(ScrollTrigger);
	}

	destroy() {
		super.destroy();
	}

	show() {
		// if (this.template != this.id) return;
		this.createScrollTrigger();
		console.log('🔼 Show productview Page');
		console.log(this.element);
		each(this.components, (component) => {
			console.log(component);
			if (component.show) component.show();
		});

		GSAP.to(this.element, {
			autoAlpha: 1,
			duration: 1.5,
			ease: 'power2.out',
		});

		GSAP.to(this.elements.left.wrapper, {
			autoAlpha: 1,
			duration: 1.5,
			ease: 'power2.out',
		});

		// GSAP.to(
		// 	this.elements.right.items,
		// 	{
		// 		autoAlpha: 0,
		// 		y: 100,
		// 	},
		// 	{
		// 		autoAlpha: 1,
		// 		y: 0,
		// 		duration: 1.5,
		// 		ease: 'power2.out',
		// 		stagger: 0.1,
		// 	}
		// );

		GSAP.fromTo(
			this.elements.right.orderBtn,
			{
				autoAlpha: 0,
			},
			{
				autoAlpha: 1,
				duration: 2,
				ease: 'power2.out',
			},
			'>-1'
		);

		console.log('show');

		window.scrollTo(0, 0);
		// this.$emit('navChangeIndex', 3);
	}

	hide() {
		return new Promise((resolve) => {
			ScrollTrigger.getAll().forEach((t) => t.kill());
			GSAP.to(this.element, { autoAlpha: 0, duration: 1.5, ease: 'expo.out' });

			resolve();
		});
	}

	async slideToLeft(element) {
		return new Promise((resolve) => {
			const leftEl = element.querySelector('.instore__left');
			const rightEl = element.querySelector('.instore__right');

			GSAP.set(element, {
				position: 'absolute',
				xPercent: 0,
			});

			GSAP.fromTo(
				element,
				{
					xPercent: 0,
				},
				{
					xPercent: -100,
					duration: 2.5,
					ease: 'power2.inOut',
					onComplete: resolve,
				}
			);
		});
	}
	onResize() {
		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
	}
	async slideFromRight(element) {
		return new Promise((resolve) => {
			// GSAP.set(element, {
			// 	position: 'absolute',
			// 	xPercent: 100,
			// });
			GSAP.fromTo(
				element,
				{
					xPercent: 100,
				},
				{
					xPercent: 0,
					duration: 2.5,
					ease: 'power2.inOut',
					onComplete: resolve,
				}
			);
		});
	}

	addToWishlist() {
		this.$emit('addToWishlist', ProductController.getProduct());
	}

	update() {}

	updatePriceText() {
		if (!this.elements.right.priceText) return;
		this.elements.right.priceText.innerHTML =
			ProductController.getProductPriceString();
	}

	selectFrame(item) {
		each(this.elements.right.frameItems, (frameItem) => {
			frameItem.classList.remove('active');
		});
		item.classList.add('active');
		this.selectedFrameElement = item;
		ProductController.selectFrame(item.dataset.item);
		ProductController.updatePrice();
		this.updatePriceText();
	}

	selectSize(item) {
		each(this.elements.right.sizeItems, (sizeItem) => {
			sizeItem.classList.remove('active');
		});
		item.classList.add('active');
		console.log();
		this.selectedSizeElement = item;
		ProductController.selectSize(item.dataset.item);
		ProductController.updatePrice();
		this.updatePriceText();
	}

	addEventListeners() {
		each(this.elements.right.sizeItems, (item) => {
			item.addEventListener('click', () => {
				if (this.selectedFrameElement === item) return;
				this.selectSize(item);
			});
		});
		each(this.elements.right.frameItems, (item) => {
			item.addEventListener('click', () => {
				if (this.selectedFrameElement === item) return;
				this.selectFrame(item);
			});
		});

		this.elements.right.addToWishlistBtn.addEventListener('click', () => {
			this.addToWishlist();
		});
		// this.elements.right.orderBtn.addEventListener('click', () => {
		// 	console.log('🔼 Order button clicked');
		// 	this.addToCart();
		// });
	}

	removeEventListeners() {}
}
